import { ReadReceiptNF } from "../../../domain/usecases/read-receipt-nf";
import { ReadReceiptNFImplementation } from "../../../data/usecases/read-receipt-nf-imp";
import { makeXmls2JsonParser } from "../xml-parser/xml-2-json-parser";

export const makeReadReceiptNF = (): ReadReceiptNF =>
  new ReadReceiptNFImplementation(makeXmls2JsonParser());
